import { useState } from "react";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  IconButton,
  Typography,
  experimentalStyled,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ArrowBackIos } from "@material-ui/icons";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import MenuIcon from "@material-ui/icons/Menu";
import NavSection from "src/components/shared/NavSection";
import useAuth from "../../hooks/useAuth";
import { AppProfile } from "../../constants";
import UserPopup from "src/pages/navigation/UserPopup";
import globatechLogo from 'src/icons/globatech-logo.png';
import Scrollbar from "src/components/shared/Scrollbar";

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    // marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    overflow: "hidden",
  },
  drawerOpen: {
    width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(0),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === "light" && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    color: "warning.main",
  }),
  ...(theme.palette.mode === "dark" && {
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
    backgroundImage: "none",
  }),
  zIndex: theme.zIndex.drawer + 100,
}));
function recursiveRemove(list, menuKey: any[]) {
  return list
    .map((item) => {
      return { ...item };
    })
    .filter((item) => {
      if ("data" in item) {
        item.data = recursiveRemove(item.data, menuKey);
      }
      return !menuKey.includes(item.menuKey);
    });
}
const MiniDrawer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { userMenus } = useAuth();
  const location = useLocation();
  const menuList = userMenus !== null ? userMenus : [];
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const menus = (item: any) => {
    return {
      title: item.title,
      path: item.path,
      data: item.data ? item.data?.map(menus) : null,
    };
  };

  const sections = recursiveRemove(menuList, AppProfile.excludeMenuKey).map(
    menus
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <DashboardNavbarRoot
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: isDrawerOpen,
        })}
      >
        <Toolbar style={{ minHeight: 55, paddingLeft: 16, paddingRight: 30, display: 'flex' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: isDrawerOpen,
              })}
            >
              <MenuIcon sx={{ color: "success.contrastText" }} />
            </IconButton>
          </Box>
            
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
            {!isDrawerOpen && (
              <Avatar
                alt="InvestApp"
                src={globatechLogo}
                sx={{ width: 38, height: 38 }}
              />
            )}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <UserPopup />
          </Box>
        </Toolbar>

      </DashboardNavbarRoot>
      <Drawer
        PaperProps={{
          sx: {
            width: 250,
          },
        }}
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: isDrawerOpen,
          [classes.drawerClose]: !isDrawerOpen,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: isDrawerOpen,
            [classes.drawerClose]: !isDrawerOpen,
          }),
        }}
      >
        <div
          className={classes.toolbar}
          style={{
            minHeight: 55,
            backgroundColor:
              theme.palette.mode === "dark"
                ? "#252630"
                : theme.palette.primary.main,
            paddingRight: 0,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Avatar
            alt="InvestApp"
            src={globatechLogo}
            sx={{ width: 38, height: 38 }}
          />
          <Typography style={{ color: '#F9F6EE', fontSize: 22, fontWeight: 400, marginLeft: '6%' }}>
            Apps Config
          </Typography>
          <IconButton sx={{ p: 0 }} onClick={toggleDrawer}>
            <ArrowBackIos
              sx={{ color: "success.contrastText" }}
              fontSize="medium"
            />
          </IconButton>
        </div>
        <div>
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              maxHeight: "calc(100vh - 100px)",
            }}
          >
            <Scrollbar>
              <Box sx={{ p: 1 }}>
                {sections.map((section, index) => (
                  <div key={index.toString()}>
                    <NavSection
                      path={section.path}
                      key={section.menuKey}
                      pathname={location.pathname}
                      sx={{
                        "& + &": {
                          mt: 1,
                        },
                      }}
                      {...section}
                    />
                    {index < sections.length - 1 && <Divider sx={{ mb: 1 }} />}
                  </div>
                ))}
              </Box>
            </Scrollbar>
          </Box>
        </div>
      </Drawer>
    </div>
  );
};

export default MiniDrawer;
